import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";

import "../css/presentacionbuscador.css";
import chef from "../img/chef.png";
import mozo from "../img/mozo.png";

function PresentacionBuscador() {
  var options = ["Marketing", "Servicio", "Arquitectura", "Carta", "Personal", "Franquicia"];

  return (
    <div className="contPresentacion text-center">
      <div className="p-4">
        <div className="row">
          <div className="col-md-4 d-none d-md-block">
            <img src={chef} />
          </div>
          <div className="col-md-4 pt-4 mt-2">
            <h1 className="tituloPrincipal">
              ¿Que te gustaría aprender?
            </h1>
            <p className="text-secondary mt-4">
              Encuentra todo lo necesario para un mejor crecimiento en Vidón bar
            </p>

            <div className="input-group flex-nowrap shadow-sm">
              <Typeahead
                className="form-control"
                placeholder="¿Qué estás buscando?"
                id="selections-example"
                options={options}
                labelKey="label"
              />

              <div className="input-group-text">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={24}
                  height={24}
                  color={"#000000"}
                  fill={"none"}
                >
                  <path
                    d="M17.5 17.5L22 22"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className="col-md-4 d-none d-md-block">
            <img src={mozo} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PresentacionBuscador;
